export class SurveyGroups {
}
//# sourceMappingURL=survey_groups.js.map